import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import ConfirmationModal, { useConfirmationModal } from '../../../common/modals/ConfirmationModal';

import Icons from '../../../../icons';

const EditCourseBlock = props => {
  const [isOpen, setIsOpen] = useState(props.isOpen || false);

  const toggleBlockOpen = () => {
    setIsOpen(!isOpen);
  };

  const deleteConfirmation = useConfirmationModal();

  const openDeleteConfirmation = e => {
    deleteConfirmation.open(() => () => {
      props.deleteAction();

      e.stopPropagation();
    });
  };

  return (
    <>
      <ConfirmationModal state={deleteConfirmation} />
      <div className="admin-block-container">
        <div className="admin-block-header" onClick={toggleBlockOpen}>
          <div className="is-flex align-items-center">
            <p>{props.title}</p>
            {props.deleteAction && (
              <button
                className="button is-danger ml-20px"
                onClick={openDeleteConfirmation}
                title="Delete course section"
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            )}
          </div>

          <div>{!isOpen ? <Icons.CaretDown /> : <Icons.CaretUp />}</div>
        </div>
        {isOpen && <div className="admin-block-content">{props.children}</div>}
      </div>
    </>
  );
};

EditCourseBlock.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  deleteAction: PropTypes.func,
};

export default EditCourseBlock;
